import React from "react";
import { Tabs } from "antd";

const { TabPane } = Tabs;

const TabSection = ({ tabname, scheduleType, onTabChange, onScheduleTypeChange }) => {
  return (
    <div>
      <Tabs defaultActiveKey="sms" className="campaign-tabs" onChange={onTabChange}>
        <TabPane tab={<span className="text-info-color px-3 fw-semibold fs-4">SMS</span>} key="sms" />
        {/* <TabPane tab={<span className="text-info-color px-3 fw-semibold fs-4">MMS</span>} key="mms" /> */}
      </Tabs>

      <Tabs defaultActiveKey="onetime" activeKey={scheduleType} className="sub-tabs mt-3" onChange={onScheduleTypeChange}>
        <TabPane tab={<span className="fs-5">One Time</span>} key="onetime" />
        <TabPane tab={<span className="fs-5">Recurring</span>} key="recurring" />
      </Tabs>
    </div>
  );
};

export default TabSection;
